import { defineMessages } from "@formatjs/intl";

const PREFIX = "lms.case-example.technical-pov-slide";
export const messages = defineMessages({
  title: {
    id: `${PREFIX}.title`,
  },
  accordionItem1Title: {
    id: `${PREFIX}.accordion-item1.title`,
  },
  accordionItem2Title: {
    id: `${PREFIX}.accordion-item2.title`,
  },
  accordionItem3Title: {
    id: `${PREFIX}.accordion-item3.title`,
  },
  accordionItem3Description: {
    id: `${PREFIX}.accordion-item3.description`,
  },
  accordionItem1aTitle: {
    id: `${PREFIX}.accordion-item1a.title`,
  },
  accordionItem1aDescription: {
    id: `${PREFIX}.accordion-item1a.description`,
  },
  accordionItem1bTitle: {
    id: `${PREFIX}.accordion-item1b.title`,
  },
  accordionItem1bDescription: {
    id: `${PREFIX}.accordion-item1b.description`,
  },
  accordionItem1cTitle: {
    id: `${PREFIX}.accordion-item1c.title`,
  },
  accordionItem1cDescription: {
    id: `${PREFIX}.accordion-item1c.description`,
  },
  accordionItem1dTitle: {
    id: `${PREFIX}.accordion-item1d.title`,
  },
  accordionItem1dDescription: {
    id: `${PREFIX}.accordion-item1d.description`,
  },
  bioNote: {
    id: `${PREFIX}.bio-note`,
  },
  readMore: {
    id: `${PREFIX}.read-more`,
  },
  simulations: {
    id: `${PREFIX}.simulations`,
  },
  view360Image: {
    id: `${PREFIX}.view-360-image`,
  },
  view360: {
    id: `${PREFIX}.view-360`,
  },
  collaboration: {
    id: `${PREFIX}.collaboration-info`,
  },
  signalFlowMenuLogical: {
    id: `${PREFIX}.signal-flow-menu-logical`,
  },
  signalFlowMenuPhysical: {
    id: `${PREFIX}.signal-flow-menu-physical`,
  },
  modalSignalFlowTitle: {
    id: `${PREFIX}.signal-flow-modal.title`,
  },
  modalSignalFlowDescription: {
    id: `${PREFIX}.signal-flow-modal.description`,
  },
  modalSystemTuningTitle: {
    id: `${PREFIX}.system-tuning-modal.title`,
  },
  modalSystemTuningDescription: {
    id: `${PREFIX}.system-tuning-modal.description`,
  },
  modalSpeakerDistributionConceptTitle: {
    id: `${PREFIX}.speaker-distribution-modal.concept.title`,
  },
  modalSpeakerDistributionConceptDescription: {
    id: `${PREFIX}.speaker-distribution-modal.concept.description`,
  },
  modalSpeakerDistributionDesignTitle: {
    id: `${PREFIX}.speaker-distribution-modal.design.title`,
  },
  modalSpeakerDistributionDesignDescription: {
    id: `${PREFIX}.speaker-distribution-modal.design.description`,
  },
  modalSpeakerDistributionDesignLinkTitle: {
    id: `${PREFIX}.speaker-distribution-modal.design.link-title`,
  },
  modalSpeakerDistributionDesignHref: {
    id: `${PREFIX}.speaker-distribution-modal.design.href`,
  },
  modalSpeakerDistributionSelectionTitle: {
    id: `${PREFIX}.speaker-distribution-modal.selection.title`,
  },
  modalSpeakerDistributionSelectionDescription: {
    id: `${PREFIX}.speaker-distribution-modal.selection.description`,
  },
  modalSpeakerFrontTitle: {
    id: `${PREFIX}.speaker-modal.front.title`,
  },
  modalSpeakerFrontDescription: {
    id: `${PREFIX}.speaker-modal.front.description`,
  },
  modalSpeakerFrontImgInfo: {
    id: `${PREFIX}.speaker-modal.front.img-info`,
  },
  modalSpeakerCeilingTitle: {
    id: `${PREFIX}.speaker-modal.ceiling.title`,
  },
  modalSpeakerCeilingDescription: {
    id: `${PREFIX}.speaker-modal.ceiling.description`,
  },
  modalSpeakerCeilingImgInfo: {
    id: `${PREFIX}.speaker-modal.ceiling.img-info`,
  },
  modalSpeakerFrontbassTitle: {
    id: `${PREFIX}.speaker-modal.frontbass.title`,
  },
  modalSpeakerFrontbassDescription: {
    id: `${PREFIX}.speaker-modal.frontbass.description`,
  },
  modalSpeakerFrontbassImgInfo: {
    id: `${PREFIX}.speaker-modal.frontbass.img-info`,
  },
  modalSpeakerCeilingbassTitle: {
    id: `${PREFIX}.speaker-modal.ceilingbass.title`,
  },
  modalSpeakerCeilingbassDescription: {
    id: `${PREFIX}.speaker-modal.ceilingbass.description`,
  },
  modalSpeakerCeilingbassImgInfo: {
    id: `${PREFIX}.speaker-modal.ceilingbass.img-info`,
  },
  modalSpeakerSurroundsideTitle: {
    id: `${PREFIX}.speaker-modal.surroundside.title`,
  },
  modalSpeakerSurroundsideDescription: {
    id: `${PREFIX}.speaker-modal.surroundside.description`,
  },
  modalSpeakerSurroundsideImgInfo: {
    id: `${PREFIX}.speaker-modal.surroundside.img-info`,
  },
  modalSpeakerSurroundbackTitle: {
    id: `${PREFIX}.speaker-modal.surroundback.title`,
  },
  modalSpeakerSurroundbackDescription: {
    id: `${PREFIX}.speaker-modal.surroundback.description`,
  },
  modalSpeakerSurroundbackImgInfo: {
    id: `${PREFIX}.speaker-modal.surroundback.img-info`,
  },
  modalSimulationTitle: {
    id: `${PREFIX}.simulation-modal.title`,
  },
  modalSimulationDescription1: {
    id: `${PREFIX}.simulation-modal.description1`,
  },
  modalSimulationDescription2: {
    id: `${PREFIX}.simulation-modal.description2`,
  },
  modalSimulationDescription3: {
    id: `${PREFIX}.simulation-modal.description3`,
  },
  modalSimulationDescription4: {
    id: `${PREFIX}.simulation-modal.description4`,
  },
  modalSimulationDescription5: {
    id: `${PREFIX}.simulation-modal.description5`,
  },
  modalSimulationDescription6: {
    id: `${PREFIX}.simulation-modal.description6`,
  },
  modalVenueTitle: {
    id: `${PREFIX}.venue-modal.title`,
  },
  modalVenueDescription: {
    id: `${PREFIX}.venue-modal.description`,
  },
  modalVenuePhotoAuthor: {
    id: `${PREFIX}.venue-modal.photo-author`,
  },
  interviews1Title: {
    id: `${PREFIX}.interviews.1.title`,
  },
  interviews1Description: {
    id: `${PREFIX}.interviews.1.description`,
  },
  interviews2Title: {
    id: `${PREFIX}.interviews.2.title`,
  },
  interviews2Description: {
    id: `${PREFIX}.interviews.2.description`,
  },
  interviews3Title: {
    id: `${PREFIX}.interviews.3.title`,
  },
  interviews3Description: {
    id: `${PREFIX}.interviews.3.description`,
  },
  interviews4Title: {
    id: `${PREFIX}.interviews.4.title`,
  },
  interviews4Description: {
    id: `${PREFIX}.interviews.4.description`,
  },
  interviews1BioNote: {
    id: `${PREFIX}.interviews.1.bio-note`,
  },
  interviews2BioNote: {
    id: `${PREFIX}.interviews.2.bio-note`,
  },
  interviews3BioNote: {
    id: `${PREFIX}.interviews.3.bio-note`,
  },
  interviews4BioNote: {
    id: `${PREFIX}.interviews.4.bio-note`,
  },
});
